import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

import Login from "../pages/front/auth/Login.vue";
import Register from "../pages/front/auth/Register.vue";
import Forgot from "../pages/front/auth/Forgot.vue";
import Verify from "../pages/front/auth/CodeVerification.vue";
// user components

import Interest from "../pages/front/auth/Interest.vue";
import Package from "../pages/front/auth/Package.vue";
import CompleteProfile from "../pages/front/auth/CompleteProfile.vue";
import Profiles from "../pages/front/straight/childs/Profiles";
import PreviewProfiles from "../pages/front/straight/childs/PreviewProfile.vue";
import Notifications from "../pages/front/straight/childs/Notifications";
import Chat from "../pages/front/straight/childs/Chat";
import Settings from "../pages/front/straight/childs/Settings";
import ChatCard from "../components/chat/ChatCard.vue";
import Notification from "../components/notifications/Notification.vue";
import ProfileSetting from "../components/settings/ProfileSetting.vue";
import NotFound from "@/pages/front/straight/childs/404.vue";
// premium components

import MainSectionVue from "@/components/premium/MainSection.vue";
// import ChatList from "@/components/premium/chat/Chat.vue";
// import ConversationMessages from "@/components/premium/chat/ConversationMessages.vue";
import PremiumChat from "../pages/front/straight/childs/PremiumUserList.vue";
import SettingsPremium from "@/components/premium/PremiumSettings.vue";
import PremiumNotificationVue from "@/components/premium/PremiumNotification.vue";
import SingleNotification from "@/components/premium/PremiumSingleNotification.vue";
import PremiumMyProfileVue from "@/pages/front/straight/childs/PremiumMyProfile.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: () => {
        let data = null;
        if (
          store.getters.StateUser.data.account_type ||
          JSON.parse(localStorage.getItem("userInfo"))
        )
          data =
            store.getters.StateUser.data.account_type ||
            JSON.parse(localStorage.getItem("userInfo")).data.account_type;
        console.log("Data", data);
        if (data !== null) {
          if(data === '0'){
          return { path: "/interest" };
           
          }
          const types = {
            1: "lesbian",
            2: "gay",
            3: "straight",
          };
          const type = types[data];
          return { path: "/" + type + "/profiles" };
        }  else {
          return { path: "/login" };
        }
      },
    },
    {
      path: "/login",
      name: "Login",
      components: {
        default: Login,
        middleSection: PreviewProfiles,
        premium: Login,
      },
      meta: {
        naviView: false,
        auth: false,
      },
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        naviView: false,
        auth: false,
      },
    },
    {
      path: "/plan",
      name: "Plan",
      component: Package,
      meta: {
        naviView: false,

        auth: false,
      },
    },
    {
      path: "/verify",
      name: "Verify",
      component: Verify,
      meta: {
        naviView: false,
        auth: false,
      },
    },
    {
      path: "/forgot-password",
      name: "Forgotpassword",
      component: Forgot,
      meta: {
        naviView: false,
        auth: false,
      },
    },
    {
      path: "/:type/my-profile",
      name: "MyProfile",
      components: {
        default: Profiles,
        middleSection: PreviewProfiles,
        premium: PremiumMyProfileVue,
      },
    },
    {
      path: "/:type/profiles",
      name: "Profiles",
      components: {
        default: Profiles,
        middleSection: PreviewProfiles,
        premium: MainSectionVue,
      },
      meta: {
        auth: true,
      },
      children: [
        {
          path: ":id",
          name: "SingleProfile",
          components: {
            default: Profiles,
            middleSection: PreviewProfiles,
          },
          meta: {
            auth: true,
          },
        },
      ],
    },
    {
      path: "/:type/chats",
      name: "Chats",
      components: {
        default: Chat,
        middleSection: ChatCard,
        premium: PremiumChat,
      },
      meta: {
        auth: true,
      },
      children: [
        {
          path: ":id",
          name: "SingleChat",
          components: {
            default: Chat,
            middleSection: ChatCard,
            premium: "",
          },
          meta: {
            auth: true,
          },
        },
      ],
    },
    {
      path: "/:type/settings",
      name: "Settings",
      components: {
        default: Settings,
        middleSection: ProfileSetting,
        premium: SettingsPremium,
      },
      meta: {
        auth: true,
      },
      children: [
        {
          path: ":setting",
          name: "SelectedSetting",
          component: Settings,
          meta: {
            auth: true,
          },
        },
      ],
    },
    {
      path: "/:type/notifications",
      name: "Notifications",
      components: {
        default: Notifications,
        middleSection: Notification,
        premium: PremiumNotificationVue,
      },
      meta: {
        auth: true,
      },
      children: [
        {
          path: ":id",
          name: "SingleNotification",
          components: {
            default: Notifications,
            middleSection: Notification,
            premium: SingleNotification,
          },
          meta: {
            auth: true,
          },
        },
      ],
    },
    {
      path: "/:type/tutorial",
      name: "Tutorial",
      component: Notifications,
      meta: {
        auth: true,
      },
      children: [
        {
          path: ":id",
          name: "SingleTutorial",
          components: {
            default: Notifications,
            middleSection: Notification,
          },
          meta: {
            auth: true,
          },
        },
      ],
    },
    {
      path: "/interest",
      name: "Interest",
      component: Interest,
      meta: {
        naviView: false,
        auth: true,
      },
    },
    {
      path: "/complete-profile",
      name: "Completeprofile",
      component: CompleteProfile,
      meta: {
        naviView: false,
        auth: true,
      },
    },
    {
      path: "*",
      name: "Notfound",
      component: NotFound, // 404 Component needs to go here
      meta: { naviView: false, auth: false },
    },
  ],
});

router.beforeEach((to, from, next) => {
  console.log(to.matched.map((record) => record));
  if (to.matched.some((record) => record.meta.auth)) {
    if (
      localStorage.getItem("token") &&
      JSON.parse(localStorage.getItem("token")).data.token
    ) {
      return typeChecker(to, from, next);
    } else {
      next({
        path: "/login",
      });
    }
  } else next();
});

function typeChecker(to, from, next) {
  const pathChecker =
    to.path === "/interest" || to.path === "/complete-profile";
  if (pathChecker) next();
  const data =
    store.getters.StateUser.data.account_type ||
    JSON.parse(localStorage.getItem("userInfo")).data.account_type;
  if (to.path === "/interest" && data === "0") {
    next();
  }
 

  const types = {
    1: "lesbian",
    2: "gay",
    3: "straight",
  };
  
  const paramType = to.params.type;
  const checker = types[data] === paramType;
  if (checker) {
    next();
  } else {
    next({
      name: "Notfound",
    });
  }
}

export default router;
